'use client';

import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { AsideTopEntitiesList } from '@/components/shared';
import { AppRoutes } from '@/i18n/constants';
import { bestProvidersQueryOptions } from '@/queries/publicSidebars.queries';

export const BestProviders = () => {
  const t = useTranslations('providers');

  const { data: providers } = useQuery(bestProvidersQueryOptions());

  if (!providers || !providers?.items) {
    return null;
  }

  const transformedProviders = providers.items.map(provider => ({
    name: provider.name,
    href: AppRoutes.providersSlugPaged(provider.alias),
  })) ?? [];

  return <AsideTopEntitiesList title={t('best-providers')} list={transformedProviders} />;
};
